import React from "react";
import { useLocation } from "react-router-dom";

/* La landing lleva su propia atmósfera: esta capa viste el resto de la app */
function AmbientePanel() {
	const { pathname } = useLocation();

	if (pathname === "/") {
		return null;
	}

	return (
		<>
			<span className="fondo-panel" aria-hidden="true" />
			<aside className="reticula-panel" aria-hidden="true">
				<span className="reticula-panel__linea" />
				<span className="reticula-panel__linea" />
				<span className="reticula-panel__linea" />
			</aside>
			<aside className="grano-panel" aria-hidden="true" />
		</>
	);
}

export default AmbientePanel;
